import { Dispatch, SetStateAction } from 'react'

import { Setting } from '@/features/videos/service'
import { Checkbox, Tooltip } from '@it-incubator/ui-kit'
import { formatWindowDate, formatWindowRange, lessThanYearLeft } from 'utils'

import s from './MaxStudentStartCourseDateCell.module.css'

type Props = {
  setSettingIds: Dispatch<SetStateAction<string[]>>
  settingIds: string[]
  settings: Setting[]
}

export const MaxStudentStartCourseDateCell = ({ setSettingIds, settingIds, settings }: Props) => {
  const settingIdChangeHandler = (settingId: string) => {
    if (settingIds.includes(settingId)) {
      setSettingIds(settingIds.filter(id => id !== settingId))

      return
    }

    setSettingIds([...settingIds, settingId])
  }

  return (
    <div className={s.container}>
      <div className={s.dateContainer}>
        {settings.map(setting => {
          const maxStartDateString = formatWindowDate(setting.maxStudentStartCourseDate)
          const rangeTooltip = formatWindowRange(
            setting.minStudentStartCourseDate,
            setting.maxStudentStartCourseDate
          )

          // Нет верхней границы (null) → не подсвечиваем красным как "скоро истечёт".
          const isLessThanYearLeft =
            setting.maxStudentStartCourseDate !== null &&
            setting.maxStudentStartCourseDate !== undefined &&
            lessThanYearLeft(new Date(setting.maxStudentStartCourseDate))
          const redTextClassName = isLessThanYearLeft ? s.redText : ''

          const settingId = setting.id as string
          const selected = settingIds.includes(settingId)

          return (
            <div className={`${s.dateAndCheckboxContainer} ${redTextClassName}`} key={setting.id}>
              <Checkbox checked={selected} onChange={() => settingIdChangeHandler(settingId)} />

              <div>{maxStartDateString}</div>

              <div className={s.tooltip}>
                <Tooltip>
                  <p>{rangeTooltip}</p>
                </Tooltip>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
